import { ERequestStatus } from 'src/api/enumRequest';
import { IPaymentState } from './interface';

export const initialPaymentState: IPaymentState = {
  getPayment: {
    payment: null,
    status: ERequestStatus.none,
    error: '',
  },

  widgetLanguages: [],

  widgetSettings: { merchantName: '', redirectUrl: '' },

  getPaymentTransactions: [],

  createPaymentAddress: {
    address_id: '',
    address: '',
    address_currency_id: '',
    status: ERequestStatus.none,
    error: '',
  },
};
